const https = require('https');
const { SecretsManagerClient, GetSecretValueCommand } = require('@aws-sdk/client-secrets-manager');
const Promise = require('bluebird');

const standardConfig = require('./standardConfig');
const urlConfig = require('./urlConfig');
const mappers = require('./mappers');

const sslAgent = new https.Agent({
    keepAlive: true,
    maxSockets: 50,
    rejectUnauthorized: true
});
if (sslAgent.setMaxListeners) {
    sslAgent.setMaxListeners(10);
}

async function getSecrets(SecretId, region = 'us-east-1') {
    const client = new SecretsManagerClient({
        region,
        httpOptions: { connectTimeout: 3000, timeout: 1000 },
        logger: console
    });

    const command = new GetSecretValueCommand({ SecretId });

    try {
        const response = await client.send(command);
        return JSON.parse(response.SecretString);
    } catch (error) {
        throw error.code === 'TimeoutError'
            ? { secretsManagerTimeout: true }
            : error;
    }
}

const fetchConfig = (env) => {
    if (env === 'test') {
        return standardConfig['test'];
    }

    return Promise.all([getSecrets(`cforce-build-${env}`), getSecrets(`cforce-DB-${env}`)]).then(([credentialsSecrets, databaseSecrets]) => {
        const specificConfig = standardConfig[env];
        if (!specificConfig) {
            return Promise.reject(`env was not a recognized value: ${env}`);
        }

        specificConfig.credentialsSecrets = credentialsSecrets;
        specificConfig.dbSecrets = databaseSecrets;

        return specificConfig;
    });
};

const getUrlConfig = (env) => {
    const specificConfig = urlConfig[env];

    if (!specificConfig) {
        throw new Error(`env was not a recognized value: ${env}`);
    }

    return specificConfig;
};

let isConfigSetup = false;
let config = standardConfig[process.env.EMVIO_CONFIG_ENV || 'test'];

function getConfig() {
    return config;
}

async function setupConfig() {
    if (!isConfigSetup) {
        try {
            config = await fetchConfig(process.env.EMVIO_CONFIG_ENV);
            isConfigSetup = true;
        } catch (error) {
            console.error('->configError', error);
        }
    }

    return config;
}

module.exports = {
    getSecrets,
    fetchConfig,
    getConfig,
    getUrlConfig,
    setupConfig,
    mappers
};
